import React, { useState } from 'react'
import { Trans, Button } from '../../atoms'
import { Form, Formik } from 'formik'
import FormField from '../../atoms/FormField/FormField'
import FormFile from '../../atoms/FormFile/FormFile'
import { api } from '../../../utils'
import { CARICAMENTOBOZZEDIGITALIORDINE } from '../../../utils/endpoint'
import { useRouter } from 'next/router'
import Alert from '../../atoms/Alert/Alert'
import { AlertTriangleLine, Info } from '../../atoms/NewIcons'
import useTrans from '../../../hooks/useTrans'
import * as Sentry from '@sentry/browser'
import MyImage from '../../atoms/MyImage/MyImage'

api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFTOKEN'

export const UploadBozzaDigitale = ({
  personalizzazione,
  ordine,
  handleUploadBozzaDigitale,
  righe,
}) => {
  const t = useTrans()
  const router = useRouter()
  const lang = router.query.lang

  const [successMessage, setSuccessMessage] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const [uploading, setUploading] = useState(false)

  const onBozzaDigitaleUpload = async (values) => {
    setUploading(true)

    let formData = new FormData()
    formData.append('bozza_digitale', values.file)

    try {
      let data = null
      for (const riga of righe) {
        const response = await api.put(`${CARICAMENTOBOZZEDIGITALIORDINE}${riga.id}/`, formData, {
          params: { lang, ordine_id: ordine.id },
        })
        data = await response.data
      }

      setBozzaDigitaleUrl(data.bozza_digitale_url)
      setNomeBozzaDigitale(values.file.name)

      handleUploadBozzaDigitale(personalizzazione.id, true)

      setErrorMessage('')
      setSuccessMessage('Bozza digitale caricata con successo')
    } catch (error) {
      setSuccessMessage('')
      setErrorMessage('Errore nel caricamento della bozza digitale')
      Sentry.captureException(error)
    }

    setUploading(false)
  }

  const [nomeBozzaDigitale, setNomeBozzaDigitale] = useState(personalizzazione.bozza_digitale_name)
  const [bozzaDigitaleUrl, setBozzaDigitaleUrl] = useState(personalizzazione.bozza_digitale_url)

  return (
    <div>
      <div className="fp-upload-bozza">
        {(errorMessage || successMessage) && (
          <div className="fp-upload-bozza__alerts">
            {errorMessage && (
              <Alert placeholder={errorMessage} variant="error" icon={<AlertTriangleLine />} />
            )}
            {successMessage && (
              <Alert placeholder={successMessage} variant="info" icon={<Info />} />
            )}
          </div>
        )}
        <Formik
          initialValues={{
            file: null,
          }}
          enableReinitialize={true}
          onSubmit={(values, { resetForm }) => {
            onBozzaDigitaleUpload(values).then(() => {
              resetForm({
                errors: {
                  file: 'Required',
                },
              })
            })
          }}
          validateOnChange={true}
          validateOnMount={true}
          validate={(values) => {
            const errors = {}

            if (!values.file) {
              errors.file = 'Required'
            } else if (
              !values.file.type.endsWith('jpg') &&
              !values.file.type.endsWith('jpeg') &&
              !values.file.type.endsWith('png')
            ) {
              errors.file = 'Invalid type'
            }

            return errors
          }}
        >
          {({ values, handleChange, errors, isValid, setFieldValue }) => (
            <Form>
              <div className="fp-upload-bozza__fieldsets">
                <FormField label={t('File bozza digitale')}>
                  <FormFile
                    placeholder={values.file?.name ? values.file.name : t('Carica file')}
                    id="file"
                    name="file"
                    accept=".jpg,.jpeg,.png"
                    onChange={(event) => setFieldValue('file', event.target.files[0])}
                  />
                </FormField>
                <p className="fp-upload-bozza__notes">
                  {t('Formati consentiti')}: .jpg, .jpeg, .png
                </p>
              </div>
              <div>
                <Button
                  type="submit"
                  label={t('Upload')}
                  variant="primary"
                  size="large"
                  disabled={!isValid || uploading}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <div>
        <div className="fp-bozza-digitale">
          <p className="fp-bozza-digitale__content">
            <span>
              <Trans chiave="Bozza digitale: " />
            </span>
            {!bozzaDigitaleUrl ? (
              <span>
                <Trans chiave="Nessuna bozza digitale caricata" />
              </span>
            ) : (
              <span>{nomeBozzaDigitale}</span>
            )}
          </p>
          {bozzaDigitaleUrl && (
            <div className="fp-bozza-digitale__link">
              <a href={bozzaDigitaleUrl} target="_blank">
                <MyImage
                  src={bozzaDigitaleUrl}
                  className="fp-bozza-digitale__image"
                  width={96}
                  height={96}
                  objectFit={'contain'}
                />
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
